import styles from "./index.module.css"
import ConditionalView from "components/ConditionalView"
import cn from "classnames"
import Loader from "components/LoadingIndicator/"
import ReactTooltip from "react-tooltip"
import { useState } from "react"
import TooltipWrapper from "../TooltipWrapper"
const Button = (props: {
  text?: string
  icon?: string
  leftIcon?: string
  onClick?: any
  disabled?: boolean
  loading?: boolean
  loadingColor?: string
  loadOnClick?: boolean
  type?: string
  style?: any
  className?: any
  tooltip?: string
  tag?: string | null
  tagBg?: string
  hoverErrorText?: string
}) => {
  const id = `btn-${Math.random()}`

  const [loading, setLoading] = useState(false)

  if (props.loading || loading) {
    return (
      <div
        className={cn(
          styles.container,
          styles[props.type ?? ""],
          { [styles.disabled]: props.disabled },
          props.className
        )}
      >
        <Loader loading color={props.loadingColor ?? "white"} />
      </div>
    )
  }

  return (
    <TooltipWrapper
      text={props.hoverErrorText}
      isError={!!props.hoverErrorText}
    >
      <div
        data-tip
        data-for={id}
        className={cn(
          styles.container,
          styles[props.type ?? ""],
          {
            [styles.disabled]: props.disabled,
            relative: !!props.tag,
          },
          props.className
        )}
        style={props.style}
        onClick={(e) => {
          if (props.loadOnClick) setLoading(true)
          props.onClick?.(e)
        }}
      >
        <ConditionalView condition={!!props.leftIcon}>
          <i className={props.leftIcon} style={{ paddingRight: "8px" }} />
        </ConditionalView>
        {props.text ? props.text : null}
        <ConditionalView condition={!!props.icon}>
          <i
            className={props.icon}
            style={{ padding: props.text ? "0px 0px 0px 8px" : "auto" }}
          />
        </ConditionalView>
        <Loader loading={!!props.loading} color="white" />
        <ConditionalView condition={!!props.tooltip}>
          <ReactTooltip id={id}>{props.tooltip}</ReactTooltip>
        </ConditionalView>
        <ConditionalView condition={!!props.tag}>
          <div
            className={cn(
              "inline-flex justify-center items-center text-xs text-white rounded-full ml-1 absolute -top-2.5 right-1 w-5 h-5 ",
              {
                ["bg-slate-400"]: !props.tagBg,
                [props.tagBg ?? ""]: !!props.tagBg,
              }
            )}
          >
            {props.tag}
          </div>
        </ConditionalView>
      </div>
    </TooltipWrapper>
  )
}

export default Button
